import React, { forwardRef } from 'react';
import type { ReactSwitchProps } from 'react-switch';
import ReactSwitch from 'react-switch';

interface SwitchProps {
  defaultChecked?: boolean;
  checked: boolean;
  onChange: (val: boolean) => void;
  id?: string;
}

export const Switch = forwardRef<ReactSwitch, SwitchProps & ReactSwitchProps>(
  function Switch(props: SwitchProps & ReactSwitchProps, ref) {
    const { defaultChecked, checked, onChange, ...rest } = props;
    const [internalChecked, setInternalChecked] =
      React.useState(defaultChecked);
    const isUncontrolled = checked === null || checked === undefined;
    return (
      <ReactSwitch
        {...rest}
        ref={ref}
        checked={(isUncontrolled ? internalChecked : checked) || false}
        onChange={(val: boolean) => {
          if (isUncontrolled) setInternalChecked(val);
          if (onChange) onChange(val);
        }}
      />
    );
  }
);
